import axios from "axios";
import { environment } from "../../../environment";
export const url = (planId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account/v2/plans/${planId}`
        : `https://middleware.uat.farther.com/account/v2/plans/${planId}`;
};
export default async function deletePlanV2(planId, config) {
    return await axios.delete(url(planId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
}
//# sourceMappingURL=deletePlanV2.js.map